import { CustomCell, CustomRenderer, GridCellKind } from "@glideapps/glide-data-grid";

export interface TextCellProps {
  readonly kind: "text-cell";
  readonly placeholder?: string;
  readonly onChange: (value: any, id?: string) => void;
  readonly value: string;
  readonly disabled?: boolean;
  readonly id: string;
  readonly className: string;
}

export type TextCell = CustomCell<TextCellProps>;

export const TextCellRenderer: CustomRenderer<TextCell> = {
  kind: GridCellKind.Custom,

  isMatch: (c): c is TextCell =>
    c.kind === GridCellKind.Custom && (c.data as any).kind === "text-cell",

  draw: (args, cell) => {
    const { ctx, theme, rect, hoverX, hoverY } = args;
    const { value, placeholder } = cell.data;

    ctx.save();
    ctx.beginPath();
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.clip();

    const dataFinal = value ?? "";
    const isPlaceholder = !dataFinal;
    const text = isPlaceholder ? (placeholder ?? "") : dataFinal;
    const color = isPlaceholder ? "#c6c6c6" : theme.textDark;

    const y = rect.y + rect.height / 2;
    const x = rect.x + theme.cellHorizontalPadding;

    ctx.fillStyle = color;
    ctx.textBaseline = "middle";
    ctx.textAlign = "left";

    ctx.fillText(text, x, y);
    ctx.restore();

    return true;
  },

  provideEditor: () => {
    return (p) => {

      const { data } = p.value;
      const { onChange, value, disabled, id, className } = data;

      const handlerOnChange = (newValue) => {
        let dataFinal = newValue ?? "";
        onChange(dataFinal, id);
        p.onFinishedEditing();
      };

      return (
        <input
          autoFocus
          defaultValue={value}
          onBlur={(e) => handlerOnChange(e.target.value)}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            font: "inherit",
            color: "#000000",
          }}
          className={className}
          disabled={disabled}
        />
      );
    };
  },
};
